/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Call/collaboration provider these settings apply to
 */
export type IntegrationProvider = (typeof IntegrationProvider)[keyof typeof IntegrationProvider];

export const IntegrationProvider = {
  'MS-TEAMS': 'ms-teams',
} as const;
